import instanceSettingsApi from './instanceSettingsApi';

const upsertInstanceSetting = async (app: string, key: string, value: string) => {
  try {
    const { data } = await instanceSettingsApi.put(
      `/${encodeURIComponent(app)}/${encodeURIComponent(key)}`,
      { value },
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    );
    return data;
  } catch (error) {
    console.error('[upsertInstanceSetting] Failed:', error);
    throw error;
  }
};

export default upsertInstanceSetting;
